var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiAssistant = function SvgAiAssistant(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C11.8096 27.5 9.74215 26.9786 7.91406 26.0537L7.76953 25.9805L7.6084 26.0068L2.11914 26.8936L3.00098 22.0898L3.03906 21.8848L2.91992 21.7139C1.3948 19.5274 0.5 16.8689 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5Z",
    fill: "url(#brand_gradient_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C11.8096 27.5 9.74215 26.9786 7.91406 26.0537L7.76953 25.9805L7.6084 26.0068L2.11914 26.8936L3.00098 22.0898L3.03906 21.8848L2.91992 21.7139C1.3948 19.5274 0.5 16.8689 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5Z",
    stroke: "url(#brand_gradient_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 10.1718C10.1358 9.2254 10.7328 8.42738 11.5185 7.91906C12.3043 7.41074 13.2281 7.22493 14.1264 7.39453C15.0247 7.56413 15.8395 8.07821 16.4265 8.8457C17.0134 9.6132 17.3347 10.5846 17.3333 11.5878C17.3333 14.4199 13.474 15.8359 13.474 15.8359M13.5769 21.5H13.5898",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand_gradient_1",
    x1: 0,
    y1: 0,
    x2: 33.6881,
    y2: 11.9072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF7557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37BD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand_gradient_2",
    x1: 28,
    y1: 0.0000223456,
    x2: 16.0928,
    y2: 33.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF7557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37BD3"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiAssistant);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai-assistant.4a7d401a8d513001fe7f8b1613cdb888.svg";